<template>
  <div>
    <base-card :loading="loading" class="rounded-lg pb-2">
      <div
        class="d-flex justify-center text--disabled align-center gap-1 pt-1 unselectable"
      >
        <small class="lh-1">
          {{ company?.name || "Carregando..." }}
        </small>
      </div>
      <v-tabs v-model="tab" show-arrows class="rounded-lg" height="36px">
        <v-tab
          v-for="tab in !company ? [] : tabsFiltered"
          class="rounded-lg"
          :key="tab.component"
        >
          <v-icon left small>{{ tab.icon }}</v-icon>
          {{ tab.name }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" :touchless="tabsFiltered[tab]?.touchless">
        <v-tab-item
          v-for="item in !company ? [] : tabsFiltered"
          :key="item.name"
          class="pa-4"
        >
          <component
            :is="item.component"
            :company="company"
            @refresh="loadCompany"
          />
        </v-tab-item>
      </v-tabs-items>
    </base-card>

    <!-- Navgation  -->
    <v-bottom-sheet
      v-model="navigationSheet"
      inset
      max-width="550px"
      :overlay-opacity="0.8"
      content-class="elevation-0"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          dark
          style="position: fixed; bottom: 76px; right: 16px; z-index: 5"
          float
          v-bind="attrs"
          v-on="on"
          color="primary"
        >
          <v-icon> mdi-dots-grid </v-icon>
        </v-btn>
      </template>
      <div class="mb-4 px-4 d-flex w-full">
        <v-card class="pa-3 pb-1 rounded-lg w-full">
          <v-row dense class="mx-0">
            <v-col
              v-for="tab in tabsFiltered"
              :key="tab?.id"
              cols="4"
              sm="4"
              md="3"
            >
              <v-card
                @click="selectTab(tab?.id)"
                outlined
                height="90px"
                elevation="0"
                class="pa-2"
              >
                <div
                  class="d-flex align-center justify-center flex-column h-full text-center lh-1 gap-2"
                >
                  <v-icon>{{ tab.icon }}</v-icon>
                  {{ tab.name }}
                </div>
              </v-card>
            </v-col>
          </v-row>
          <div class="d-flex justify-center">
            <v-btn @click="navigationSheet = false" text small> Fechar </v-btn>
          </div>
        </v-card>
      </div>
    </v-bottom-sheet>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import COMPANY from "@/services/ultimate/company";
import CompanyData from "@/components/ultimate/company/CompanyData.vue";
import CompanyPrecification from "@/components/ultimate/company/CompanyPrecification.vue";
import CompanyCommission from "@/components/ultimate/company/CompanyCommission.vue";

export default {
  metaInfo() {
    return { title: `⚙️ ${this.company?.name || "Carregando..."}` };
  },
  data: () => ({
    loading: true,
    company: null,
    tab: null,
    navigationSheet: false,
    tabs: [
      {
        id: "company",
        name: "Dados da Empresa",
        component: "CompanyData",
        icon: "mdi-account",
      },
      {
        id: "precifications",
        name: "Precificações",
        component: "CompanyPrecification",
        icon: "mdi-calculator",
      },
      {
        id: "commission",
        name: "Comissão",
        component: "CompanyCommission",
        icon: "mdi-percent",
      },
    ],
  }),
  methods: {
    async loadCompany() {
      try {
        this.loading = true;
        const { company } = await COMPANY.getById(this.$route.params.id);
        this.company = company;
        this.loading = false;
        this.tab = 0;
        this.selectTab();
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    selectTab(tab) {
      if (tab) window.location.replace("#" + tab);
      if (this.$route.hash) {
        let hash = tab || this.$route.hash.replace("#", "");
        let index = this.tabsFiltered.findIndex((tab) => tab?.id == hash);
        if (index >= 0) this.tab = index;
        this.navigationSheet = false;
      }
    },
    vibrate() {
      if (navigator.vibrate) navigator.vibrate(50);
    },
  },
  computed: {
    ...mapGetters("company", ["selectedCompany"]),
    ...mapGetters("auth", ["hasPermission"]),
    tabsFiltered() {
      return this.tabs.filter(
        (tab) => !tab.permission || this.hasPermission(tab.permission)
      );
    },
  },
  watch: {
    tab: {
      handler(val, oldVal) {
        if (val !== null && oldVal !== null) this.vibrate();
        let tab = this.tabsFiltered[val];
        if (tab) window.location.replace("#" + tab?.id);
      },
      immediate: true,
    },
    "$route.hash"() {
      this.selectTab();
    },
    "selectedCompany.id"() {
      this.$router.push({
        name: "ultimate.companies",
      });
    },
  },
  components: {
    CompanyData,
    CompanyPrecification,
    CompanyCommission,
  },
  destroyed() {},
  mounted() {
    this.loadCompany();
  },
};
</script>

<style></style>
